<template>
  <div class="navbar">
    <nav class="nav-extended amber darken-2">
      <div class="nav-content">
        <span v-show="pageName!=='Intro'" class="nav-title" @click="confirmRedirect()">
          <img src="../assets/logo.png">
          <!-- <router-link :to="{ name: 'Intro' }">Stacker Tracker</router-link> -->
        </span>
        <span v-if="pageName === 'ViewAssets'">
          <router-link
            :to="{ name: 'AddAssets', params: { user_id } }"
            class="pulse btn-floating btn-large amber darken-4 halfway-fab"
          >
            <i class="material-icons">add</i>
          </router-link>
        </span>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      pageName: this.$router.currentRoute.name,
      user_id: this.$route.params.user_id
    };
  },
  methods: {
    updatePage() {
      this.pageName = this.$router.currentRoute.name;
      this.user_id = this.$route.params.user_id;
    },
    confirmRedirect() {
      if (this.pageName === "ViewAssets") {
        this.$alertify.confirmWithTitle(
          "Are you sure?",
          "You are about to navigate away. Remember to save the link to your assets.",
          () => {
            this.$router.push("/");
          }
        );
      } else {
        this.$router.push("/");
      }
    }
  },
  watch: {
    $route: "updatePage"
  },
  created() {
    this.updatePage();
  }
};
</script>

<style>
.navbar nav {
  padding-left: 15px;
}
nav .nav-content {
  height: 102px;
}
nav .nav-title {
  cursor: pointer;
  padding: 5px;
}
</style>




// WEBPACK FOOTER //
// src/components/Navbar.vue